import moment from 'moment';
import { DateOption, DateRange, DateOptionValue } from './types';

export const PREDEFINED_DATE_OPTIONS: DateOption[] = [
  { label: 'Today', value: 'today' },
  { label: 'Last 7 days', value: 'last7Days' },
  { label: 'Last 30 days', value: 'last30Days' },
  { label: 'This week', value: 'thisWeek' },
  { label: 'This month', value: 'thisMonth' },
  { label: 'This year', value: 'thisYear' },
  { label: 'Last 3 Months', value: 'lastThreeMonths' },
  { label: 'All Time', value: 'allTime' },
];

export const DEFAULT_DATE_OPTION_VALUE = 'allTime' as const;

export const DATE_RANGE_CALCULATORS: Record<DateOptionValue, (now: moment.Moment) => DateRange> = {
  today: (now) => ({
    startDate: now.startOf('day').toDate(),
    endDate: now.endOf('day').toDate(),
  }),
  last7Days: (now) => ({
    startDate: now.clone().subtract(6, 'days').startOf('day').toDate(),
    endDate: now.clone().endOf('day').toDate(),
  }),
  last30Days: (now) => ({
    startDate: now.clone().subtract(29, 'days').startOf('day').toDate(),
    endDate: now.clone().endOf('day').toDate(),
  }),
  thisWeek: (now) => ({
    startDate: now.clone().startOf('isoWeek').toDate(),
    endDate: now.clone().endOf('isoWeek').toDate(),
  }),
  thisMonth: (now) => ({
    startDate: now.clone().startOf('month').toDate(),
    endDate: now.clone().endOf('month').toDate(),
  }),
  thisYear: (now) => ({
    startDate: now.clone().startOf('year').toDate(),
    endDate: now.clone().endOf('year').toDate(),
  }),
  lastThreeMonths: (now) => ({
    startDate: now.clone().subtract(2, 'months').startOf('month').toDate(),
    endDate: now.clone().endOf('month').toDate(),
  }),
  allTime: () => ({
    startDate: null,
    endDate: null,
  }),
};
